import { parseISO } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';
import * as _ from 'lodash';
// eslint-disable-next-line no-restricted-imports
import * as moment from 'moment';
/**
 * Helper function for formatting the date in a human-readable format.
 *
 * **Note**: This function will format in UTC.
 *
 * @param {Date | moment.Moment | string} date - The date to format. Either as a string, Date object, or Moment object.
 * @param {boolean} truncateMonth - Whether or not to truncate the month (ie January -> Jan)
 * @returns The string formatted date (eg: "June 18, 2023").
 */
export const prettyMDY = (date: Date | moment.Moment | string, truncateMonth?: boolean): string => {
  let dateToFormat: Date;
  if (moment.isMoment(date)) {
    dateToFormat = date.toDate();
  } else if (_.isString(date)) {
    dateToFormat = new Date(date);
  } else {
    dateToFormat = parseISO(date.toISOString());
  }

  return formatInTimeZone(dateToFormat, 'Etc/Greenwich', truncateMonth ? 'LLL d, yyyy' : 'LLLL d, yyyy');
};
